export default {"src":"/_next/static/media/family.mono.5757ed19.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};